import protectedAxios from '../auth/axios.js';
import { eventBus } from '../main.js';

export const globalMixin = {
    methods: {
        // skontroluje sa systemovy parameter ci schvalovanie prebehlo v kalkulacke (vrati 0) alebo ma prebehnut vo filipovi (vrati 1)
        async schvalovaniePoPrekalkulovani(cislaPlz){
            await protectedAxios
                .get(`kalk/schvalovanie`).then(async _res => {
                    if(_res.data == 1){
                        await protectedAxios.post(`kalk/schvalovanie`,{
                            cislaPlz: cislaPlz
                        }).then(res => {
                            if (res.data?.error > 0) return Promise.reject({message: "Chyba pri schvalovaní." ,response: res});
                        }).catch(e => {
                            let error_text = "Chyba pri schvalovaní.";
                            if(e?.response?.data?.error_text){
                                error_text += " " + e?.response?.data?.error_text;
                            }
                            console.error(e);
                            eventBus.$emit('snack-error', error_text );
                            return Promise.reject(e);
                        });
                    }else{
                        console.log("Schvalovanie prebehlo v kalkulačke.")
                    }
                });
        }
    }
}